import React from 'react';
import useUtilizationIsTooHighForIFUnstake from '../../hooks/useUtilizationIsTooHighForIFUnstake';
import InlineAlert from 'src/components/primitives/InlineAlert/InlineAlert';
import Link from 'src/components/primitives/Link/Link';

const InsuranceFundUnstakeUtilizationCutoffMessage = (
	props: ReturnType<typeof useUtilizationIsTooHighForIFUnstake> & {
		type: 'IFPage' | 'UnstakeModal';
	}
) => {
	const semanticMessage =
		props.type === 'IFPage'
			? 'You will need to wait until it drops to a safer level to withdraw your stake.'
			: `You will still be able to begin the unstake process from this modal, but you won't be able to do the final withdrawal until it drops to a safer level.`;

	return (
		<InlineAlert
			title="Unstaking Disabled"
			variant="warning"
			className="flex-col gap-y-sm"
		>
			<p>
				Unstaking from the Insurance Fund is disabled while borrow utilization
				is high, for protocol safety. {semanticMessage}
			</p>
			<div className="flex justify-between">
				<span>Current Utilization</span>
				<span>{props.currentUtilizationPercent}%</span>
			</div>
			<div className="flex justify-between">
				<span>Cutoff Utilization</span>
				<span>{props.unstakingCutoffPct}%</span>
			</div>
			<Link
				href="https://docs.drift.trade/insurance-fund/insurance-fund-intro"
				openInNewTab
			>
				Learn more
			</Link>
		</InlineAlert>
	);
};

export default InsuranceFundUnstakeUtilizationCutoffMessage;
